function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M16.1659242,9.90212766 L12.0808178,9.90212766 L12.0808178,5.81702128 C12.0808178,5.36602395 11.7147939,5 11.2637965,5 L10.7191489,5 C10.2681516,5 9.90212766,5.36602395 9.90212766,5.81702128 L9.90212766,9.90212766 L5.81702128,9.90212766 C5.36602395,9.90212766 5,10.2681516 5,10.7191489 L5,11.2637965 C5,11.7147939 5.36602395,12.0808178 5.81702128,12.0808178 L9.90212766,12.0808178 L9.90212766,16.1659242 C9.90212766,16.6169215 10.2681516,16.9829455 10.7191489,16.9829455 L11.2637965,16.9829455 C11.7147939,16.9829455 12.0808178,16.6169215 12.0808178,16.1659242 L12.0808178,12.0808178 L16.1659242,12.0808178 C16.6169215,12.0808178 16.9829455,11.7147939 16.9829455,11.2637965 L16.9829455,10.7191489 C16.9829455,10.2681516 16.6169215,9.90212766 16.1659242,9.90212766 Z",
  id: "icon_plus-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Plus",
  transform: "translate(0.000000, -0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_plus",
  transform: "translate(-5.000000, -5.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "icon_plus-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon_plus-path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  xlinkHref: "#icon_plus-path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "UI-Color-/-Active-Color-",
  mask: "url(#icon_plus-mask-2)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
})))));

function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.92070063.svg";
export { ForwardRef as ReactComponent };